import { createContext } from 'react';
export const EntityDisplayDispatchContext = createContext({
    defaultContextValue: true,
});
EntityDisplayDispatchContext.displayName = 'EntityDisplayDispatchContext';
//# sourceMappingURL=EntityDisplayDispatchContext.js.map